import React from "react"
import { useToast } from "~/utils/Toast"
import getAppConfig from "~/utils/getAppConfig"

import { apiWorkspaceTasks } from "~/routes"
import CatchModal from "~/library/CatchModal"
import TaskForm from "./TaskForm"

interface NewTaskProps {
    isOpen: boolean
    onClose: () => void
    onSuccess?: () => void
    accountId?: string
    contactId?: string
    dealId?: string
}

const NewTask: React.FC<NewTaskProps> = ({
                                             isOpen,
                                             onClose,
                                             onSuccess,
                                             accountId,
                                             contactId,
                                             dealId,
                                         }) => {
    const { venueSlug } = getAppConfig()
    const toast = useToast()

    const handleSubmit = (formValues: any) => {
        const taskData: any = {
            title: formValues.title,
            description: formValues.description,
            task_type: formValues.taskType,
            status: formValues.status,
        }

        if (formValues.accountId) {
            taskData.account_id = formValues.accountId
        }
        if (formValues.contactId) {
            taskData.contact_id = formValues.contactId
        }
        if (formValues.dealId) {
            taskData.deal_id = formValues.dealId
        }

        const data = {
            venue_slug: venueSlug,
            task: taskData,
        }

        const req = apiWorkspaceTasks.create({ data })

        req
            .then(() => {
                toast("Task created successfully", "success")
                onSuccess?.()
                onClose()
            })
            .catch((res) => {
                toast(`${res.body?.errors?.join(", ") || "Please try again"}`, "danger")
            })
    }

    return (
        <CatchModal isOpen={isOpen} onClose={onClose} title="New Task" size="lg">
            <TaskForm
                onSubmit={handleSubmit}
                onCancel={onClose}
                presetAccountId={accountId}
                presetContactId={contactId}
                presetDealId={dealId}
            />
        </CatchModal>
    )
}

export default NewTask
